import { createTheme } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';

const theme = createTheme({
  palette: {
    primary: green
  }
})

export default theme